module.exports = __webpack_public_path__ + "img/132.c84bbd58.jpg";